import { createReducer } from 'typesafe-actions';
import { type Actions, toggleColumnDialog } from './actions.js';
import type { CONTENT_LIST_NAME } from './constants.js';

export type ContentListState = {
  showColumnConfig: boolean;
};

export type ContentListSlice = {
  [CONTENT_LIST_NAME]: ContentListState;
};

export const contentListInitialState: ContentListState = {
  showColumnConfig: false
};

export const contentListReducer = createReducer<ContentListState, Actions>(contentListInitialState).handleAction(
  toggleColumnDialog,
  (state) => ({
    showColumnConfig: !state.showColumnConfig
  })
);
